import { IMAGES } from "./imagesImports";

export const section3Images = [
    {
        src: IMAGES.MEDICAL_ASESSMENT,
        alt: "asesment",
        heading: 'Upload Your Documents',
        description: 'Submit the medical documents for evaluation.',
        backgroundColor : '#F46350'
    },
    {
        src: IMAGES.MEDICAL_ASESSMENT_1,
        alt: "asesment-1",
        heading: 'Project scope',
        description: 'We determine the length of the document, type of medical terminology used, and translator availability.',
        backgroundColor : '#7245ED'
    },
    {
        src: IMAGES.MEDICAL_ASESSMENT_2,
        alt: "asesment-2",
        heading: 'Assign a medical translator',
        description: 'A professional medical translator familiar with the field handles your content.',
        backgroundColor : '#12ABBF'
    },
    {
        src: IMAGES.MEDICAL_ASESSMENT_3,
        alt: "asesment-3",
        heading: 'Translate medical documents',
        description: 'The translator delivers a word-for-word translation.',
        backgroundColor : '#F46350'
    },
    {
        src: IMAGES.MEDICAL_ASESSMENT_4,
        alt: "asesment-4",
        heading: 'Proof and certify',
        description: 'We provide either a certified translation or a notarized translation upon request.',
        backgroundColor : '#7245ED'
    },
    {
        src: IMAGES.MEDICAL_ASESSMENT_5,
        alt: "asesment-5",
        heading: 'Deliver on time',
        description: 'All translations are delivered on time.',
        backgroundColor : '#12ABBF'
    }
];

export const section5Images = [
    {
        src: IMAGES.HEALTH,
        alt: "health",
        text: "Patients travel across borders for treatment"
    },
    {
        src: IMAGES.HOSPITAL,
        alt: "hospital",
        text: "Hospitals handle international medical records"
    },
    {
        src: IMAGES.PILLS,
        alt: "pills",
        text: "Pharmaceutical companies run multilingual clinical trials."
    },
    {
        src: IMAGES.MASK,
        alt: "mask",
        text: "Translation enables smooth communication and protects patient safety."
    }
];

export const section5V2Images = [
    {
        src: IMAGES.FOLDER,
        alt: "hospital shield",
        text: "Medical records translation"
    },
    {
        src: IMAGES.DOCUMENTVERIFIED,
        alt: "hospital symbol",
        text: "Certified medical translations"
    },
    {
        src: IMAGES.PROFILE,
        alt: "medical bag",
        text: "Record translation for legal or personal use"
    },
    {
        src: IMAGES.WRENCH,
        alt: "chemistry flask",
        text: "Translation of medical device manuals"
    },
    {
        src: IMAGES.HEDPHONE,
        alt: "headphone",
        text: "Medical interpreter support"
    }
];

export const section5V3Images = [
    {
        src: IMAGES.HOSPITALSHEILD,
        alt: 'hospital shield',
        text: 'Health insurance providers',
    },
    {
        src: IMAGES.HOSPITALSYMBOL,
        alt: 'hospital symbol',
        text: 'Hospitals and clinics',
    },
    {
        src: IMAGES.MEDICALBAG,
        alt: 'medical bag',
        text: 'Government healthcare departments',
    },
    {
        src: IMAGES.CHEMISTRYFLASK,
        alt: 'chemistry flask',
        text: 'Clinical research organizations',
    },
];

export const section6Images = [
    {
        src: IMAGES.SITEMAP,
        alt: "sitemap-img",
        text: `eVerbary offers certified medical document translation services supported by a dedicated translation team. Each translator has expertise in medical terms and the healthcare industry.
    We deliver accurate translations for healthcare providers, legal professionals, and individuals.`
    },
    {
        src: IMAGES.SCALE,
        alt: "scale-img",
        text: `You’ll receive high-quality medical translation services that ensure every word counts. We never rely on machine translation tools. We use professional human translators to handle even the most complex medical content.`
    },
    {
        src: IMAGES.FLASH,
        alt: "flash-img",
        text: `We work with hospitals, insurance providers, medical device manufacturers, research labs, and more. Our additional services include interpreting services, medical interpreter support, and language services for medical conferences.`
    }
];

export const section6V2Images = [
    {
        src: IMAGES.DOCUMENTSCAN,
        alt: "document-scan",
        text: "Careful review throughout the translation process"
    },
    {
        src: IMAGES.USBSTORAGE,
        alt: "usb-storage",
        text: "Translation memory tools to ensure consistency"
    },
    {
        src: IMAGES.STARS,
        alt: "stars",
        text: "Quality assurance checks for all documents"
    },
    {
        src: IMAGES.TIMER,
        alt: "timer",
        text: "Timely delivery even for complex medical translations"
    }
];


